// Global report-generation progress state.
//
// The report dialog lives inside the per-page grid component, so it (and any
// progress bar it owns) is destroyed on route navigation. Holding the progress
// here lets a single app-level floating bar (ReportProgressFab) keep showing the
// status while the user moves between dashboard pages and the report finishes in
// the background.
export default {
  namespaced: true,
  state: () => ({
    isGenerating: false,
    progress: 0, // 0-100
    text: '',
    complete: false, // brief "done" state shown after a report finishes
    dialogOpen: false, // true while the report dialog is visible (hides the floating bar)
    openRequestId: 0, // bumped to ask a mounted dialog to re-open itself
  }),
  mutations: {
    setGenerating(state, value) {
      state.isGenerating = value;
    },
    setProgress(state, { value, text }) {
      state.progress = Math.max(0, Math.min(100, value));
      if (text !== undefined) state.text = text;
    },
    setComplete(state, value) {
      state.complete = value;
    },
    setDialogOpen(state, value) {
      state.dialogOpen = value;
    },
    requestOpen(state) {
      state.openRequestId++;
    },
  },
};
